import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import useWorkspaceId from 'src/hooks/useWorkspaceId'

const { REACT_APP_PORTAL_API_URL } = process.env

export interface AdOptInStatus {
  hasOptedIn: boolean
  isOptOut: boolean
  profileCompleted: boolean
  termsCompleted: boolean
  agreementStatus: string | null
}

export const useAdOptInStatus = () => {
  const workspaceId = useWorkspaceId()
  const [status, setStatus] = useState<AdOptInStatus | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  const refetch = useCallback(() => {
    setRefreshKey(k => k + 1)
  }, [])

  // Fetch status on mount and when refreshKey changes
  useEffect(() => {
    if (!workspaceId || !REACT_APP_PORTAL_API_URL) return

    const token = localStorage.getItem('token')
    if (!token) return

    let cancelled = false

    axios
      .get<AdOptInStatus>(`${REACT_APP_PORTAL_API_URL}/v1/ad-opt-in/status/${workspaceId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        if (!cancelled) setStatus(data)
      })
      .catch(() => {
        // Silently ignore — badge just won't show
      })

    return () => {
      cancelled = true
    }
  }, [workspaceId, refreshKey])

  // Listen for adNetworkStatusChanged postMessage from iframe
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.eventName === 'adNetworkStatusChanged') {
        refetch()
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [refetch])

  return status
}
